interface State {
  active: boolean
}
const inactive: State = {
  active: false,
}

export interface ApplicationState {
  point: State
  subscription: State
  carat: State
  paidMembership: State
}

export const allInactive: ApplicationState = {
  point: inactive,
  subscription: inactive,
  carat: inactive,
  paidMembership: inactive,
}
